const InstituteDelhiCourse = [
    {

        data: [
            { title: "Does the college offer PhD courses?", value: "Yes" },
            { title: "Number of PhDs graduated in 2021-22", value: "3" },
            { title: "Number of PhDs graduated in 2020-21", value: "1" },
        ]
    },
    {

        data: [
            { title: "Number of PhDs graduated in 2019-20", value: "0" },
            { title: "Does the college offer postgraduate courses?", value: "Yes" },
            { title: "Number of students who completed postgraduate courses in 2021-22", value: "28" },
        ]
    },
    {

        data: [
            { title: "Number of students who completed postgraduate courses in 2020-21", value: "21" },
            { title: "Number of students who completed postgraduate courses in 2019-20", value: "28" },
        ]
    },

];

export default InstituteDelhiCourse;
